"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const malty_atoms_button_1 = require("@carlsberggroup/malty.atoms.button");
const malty_atoms_checkbox_1 = require("@carlsberggroup/malty.atoms.checkbox");
const malty_atoms_icon_1 = require("@carlsberggroup/malty.atoms.icon");
const malty_atoms_icon_wrapper_1 = require("@carlsberggroup/malty.atoms.icon-wrapper");
const malty_atoms_input_1 = require("@carlsberggroup/malty.atoms.input");
const malty_atoms_label_1 = require("@carlsberggroup/malty.atoms.label");
const malty_theme_malty_theme_provider_1 = require("@carlsberggroup/malty.theme.malty-theme-provider");
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const Select_styled_1 = require("./Select.styled");
const Select_types_1 = require("./Select.types");
const Select = ({ defaultValue = [], onValueChange, options, placeholder, label, type, error, hint, disabled = false, size = Select_types_1.SelectSize.Medium, multiple = false, selectionText = 'selected', value, search = false, dataTestId, readOnly, selectAllLabel = 'Select all', clearAllLabel = 'Clear all', clearAllOption = true, alignPosition = Select_types_1.SelectPosition.Left, required = false, onBlur, optionsZIndex = 2 }) => {
    const theme = malty_theme_malty_theme_provider_1.globalTheme;
    const id = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    const [numSize, setNumSize] = (0, react_1.useState)(theme.sizes.xl.value);
    const [showOptionList, setShowOptionList] = (0, react_1.useState)(false);
    const [selectedValueState, setSelectedValueState] = (0, react_1.useState)(value || defaultValue);
    const [queryText, setQueryText] = (0, react_1.useState)('');
    const [selectOptions, setSelectOptions] = (0, react_1.useState)(options);
    const ref = (0, react_1.createRef)();
    const toggleOptionList = () => {
        setShowOptionList(!showOptionList);
    };
    // eslint-disable-next-line consistent-return
    const handleOptionSelected = (option) => {
        const auxSelected = JSON.parse(JSON.stringify(selectedValueState));
        // eslint-disable-next-line no-restricted-globals
        event === null || event === void 0 ? void 0 : event.preventDefault();
        if (!multiple) {
            setShowOptionList(false);
        }
        if (checkIfSelected(option)) {
            if (multiple) {
                removeSelectedOption(option);
            }
            else {
                update([option]);
            }
        }
        else {
            if (!multiple) {
                return update([option]);
            }
            auxSelected.push(option);
            update(auxSelected);
        }
    };
    const checkIfSelected = (option) => !!selectedValueState.find((el) => el.value === option.value);
    const removeSelectedOption = (option) => {
        const index = selectedValueState === null || selectedValueState === void 0 ? void 0 : selectedValueState.findIndex((el) => el.value === option.value);
        const auxSelected = JSON.parse(JSON.stringify(selectedValueState));
        auxSelected === null || auxSelected === void 0 ? void 0 : auxSelected.splice(index, 1);
        update(auxSelected);
    };
    const update = (auxSelected) => {
        setSelectedValueState(auxSelected);
        onValueChange(auxSelected);
    };
    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target || null)) {
            setShowOptionList(false);
        }
    };
    (0, react_1.useEffect)(() => {
        switch (size) {
            case Select_types_1.SelectSize.Large: {
                setNumSize(theme.sizes['2xl'].value);
                break;
            }
            default: {
                setNumSize(theme.sizes.xl.value);
                break;
            }
        }
    }, [size, theme]);
    (0, react_1.useEffect)(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    });
    (0, react_1.useEffect)(() => {
        if (defaultValue.length > 0 && (value === undefined || (value === null || value === void 0 ? void 0 : value.length) === 0))
            setSelectedValueState(defaultValue);
    }, [defaultValue, value]);
    (0, react_1.useEffect)(() => {
        if (value)
            setSelectedValueState(value);
    }, [value]);
    (0, react_1.useEffect)(() => {
        setSelectOptions(options);
    }, [options]);
    const displaySelectedValues = () => {
        if (selectedValueState.length > 0) {
            if (selectedValueState.length > 2) {
                return `${selectedValueState.length} ${selectionText}`;
            }
            return selectedValueState === null || selectedValueState === void 0 ? void 0 : selectedValueState.map((selectedValue, index) => index !== 0 ? `, ${selectedValue.name}` : selectedValue.name);
        }
        return type === Select_types_1.SelectType.Inline ? label : placeholder;
    };
    const handleSearch = (query) => {
        const filterOptions = options === null || options === void 0 ? void 0 : options.filter((el) => el.name.toUpperCase().includes(query.toUpperCase()));
        setQueryText(query);
        setSelectOptions(filterOptions);
    };
    const handleSelectAll = () => {
        if (selectOptions && selectOptions.length > 0)
            update(selectOptions);
    };
    const handleClearAll = () => {
        update([]);
        if (!multiple)
            setShowOptionList(false);
    };
    const renderDefaultDropdown = () => (react_1.default.createElement(Select_styled_1.StyledMainWrapper, null,
        react_1.default.createElement(Select_styled_1.StyledOptionsWrapper, { "data-testid": `${dataTestId}-options`, isOpen: showOptionList, selectStyle: type, theme: theme, height: numSize, position: type === Select_types_1.SelectType.Inline ? alignPosition : undefined, zIndex: optionsZIndex },
            react_1.default.createElement(Select_styled_1.StyledActionsWrapper, { theme: theme },
                search && (react_1.default.createElement(Select_styled_1.StyledSearchWrapper, { theme: theme },
                    react_1.default.createElement(malty_atoms_input_1.Input, { "data-testid": `${dataTestId}-search-input`, size: size === Select_types_1.SelectSize.Medium ? malty_atoms_input_1.InputSize.Medium : malty_atoms_input_1.InputSize.Large, onValueChange: handleSearch, type: malty_atoms_input_1.InputType.Search, value: queryText, icon: malty_atoms_icon_1.IconName.Search }))),
                ((selectedValueState.length > 0 && clearAllOption) || multiple) && (react_1.default.createElement(Select_styled_1.StyledActionButtonWrapper, { height: numSize, theme: theme },
                    multiple && (react_1.default.createElement(Select_styled_1.StyledActionButton, { "data-testid": `${dataTestId}-select-all`, onClick: handleSelectAll, theme: theme }, selectAllLabel)),
                    selectedValueState.length > 0 && clearAllOption && (react_1.default.createElement(Select_styled_1.StyledActionButton, { "data-testid": `${dataTestId}-clear`, onClick: handleClearAll, theme: theme }, clearAllLabel))))),
            !disabled &&
                !readOnly &&
                (selectOptions === null || selectOptions === void 0 ? void 0 : selectOptions.map((option, index) => (react_1.default.createElement(Select_styled_1.StyledOption, { theme: theme, key: option.value, value: option.value, onClick: () => handleOptionSelected(option), height: numSize, selected: !!selectedValueState.find((el) => el.value === option.value), selectStyle: type, "data-testid": `${dataTestId}-option-${index}` },
                    multiple && (react_1.default.createElement(malty_atoms_checkbox_1.Checkbox, { fullWidth: true, "data-testid": `${dataTestId}-option-checkbox-${index}`, labelText: option.name, value: option.value, onValueChange: () => null, checked: !!selectedValueState.find((el) => el.value === option.value) })),
                    !multiple && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(Select_styled_1.StyledWrapper, { "data-testid": `${dataTestId}-option-label-${index}`, theme: theme },
                            option.icon,
                            option.name),
                        selectedValueState.find((el) => el.value === option.value) && (react_1.default.createElement(Select_styled_1.StyledCheck, { theme: theme, selectStyle: type, color: malty_atoms_icon_wrapper_1.IconColor.DigitalBlack, size: malty_atoms_icon_wrapper_1.IconSize.Small })))))))))));
    return (react_1.default.createElement(Select_styled_1.StyledMainWrapper, null,
        type !== Select_types_1.SelectType.Inline && (react_1.default.createElement(malty_atoms_label_1.Label, { label: label, "data-testid": `${dataTestId}-label`, disabled: disabled, required: required, htmlFor: id })),
        react_1.default.createElement(Select_styled_1.StyledButtonContainer, { "data-testid": dataTestId, ref: ref, selectStyle: type, theme: theme },
            react_1.default.createElement(Select_styled_1.StyledButton, { name: id, id: id, theme: theme, isActive: (selectedValueState === null || selectedValueState === void 0 ? void 0 : selectedValueState.length) > 0 || type === Select_types_1.SelectType.Inline, selectStyle: type, height: numSize, onClick: toggleOptionList, disabled: disabled, readOnly: readOnly, isError: !!error && type !== Select_types_1.SelectType.Inline, open: showOptionList, type: malty_atoms_button_1.ButtonType.Default, "data-testid": `${dataTestId}-button`, onBlur: onBlur },
                react_1.default.createElement(Select_styled_1.StyledSelectedOptionsWrapper, { theme: theme, "data-testid": `${dataTestId}-selected-values` }, displaySelectedValues()),
                react_1.default.createElement(Select_styled_1.StyledChevronDown, { theme: theme, selectStyle: type, disabled: disabled, readOnly: readOnly, open: showOptionList, color: malty_atoms_icon_wrapper_1.IconColor.DigitalBlack, size: malty_atoms_icon_wrapper_1.IconSize.Medium })),
            renderDefaultDropdown()),
        error && type !== Select_types_1.SelectType.Inline && (react_1.default.createElement(Select_styled_1.StyledError, { "data-testid": `${dataTestId}-error`, theme: theme }, error)),
        hint && !error && type !== Select_types_1.SelectType.Inline && (react_1.default.createElement(Select_styled_1.StyledHint, { "data-testid": `${dataTestId}-hint`, disabled: disabled, theme: theme }, hint))));
};
exports.Select = Select;
//# sourceMappingURL=Select.js.map